import { useQuery } from '@tanstack/react-query'

import { apiClient } from '../apiClient'

export type RejectionReasonCatalogItem = {
  code: string
  label: string
}

export type RejectionReasonCatalogResponse = {
  reasons: RejectionReasonCatalogItem[]
}

export const REJECTION_REASONS_QUERY_KEY = 'resolved-engagement-rejection-reasons-v3'

export function useGetRejectionReasons(options?: { enabled?: boolean }) {
  return useQuery<RejectionReasonCatalogResponse, Error>({
    queryKey: [REJECTION_REASONS_QUERY_KEY],
    queryFn: async () => {
      const { data } = await apiClient.get<RejectionReasonCatalogResponse>(
        '/int/v3/engagements/resolved/rejection-reasons'
      )
      return data
    },
    enabled: options?.enabled ?? true,
    staleTime: Number.POSITIVE_INFINITY,
    refetchOnWindowFocus: false,
    retry: 1,
  })
}
